<template>
    <v-layout row wrap>
        <v-flex xs12 v-if="overviewScreenMessage">
            <v-alert
            :value="true"
            :color="overviewScreenMessage.type"
            icon="check_circle"
            outline
            >
            {{ overviewScreenMessage.message }}
            </v-alert>
        </v-flex>
        <v-layout v-if="screener" class="mt-3">
            <v-flex xs12 md5>
                <h3 class="mb-2">Basic Details</h3>
                <v-layout row wrap class="py-1">
                    <v-flex xs6 class="grey--text text--darken-1">{{ $t('screener.quick.event.creation.step.form.event_url_text') }}</v-flex>
                    <v-flex xs6>
                        <a v-if="liveEventURL" :href="liveEventURL">
                            {{ liveEventURL }}
                        </a>
                        <div v-else>Unavailable</div>
                    </v-flex>
                </v-layout>
                <!-- Event Title -->
                <v-layout row wrap class="py-1">
                    <v-flex xs6 class="grey--text text--darken-1">{{ $t('screener.quick.event.creation.step.form.field.title') }}</v-flex>
                    <v-flex xs6>
                        <div>{{ screener.title }}</div>
                    </v-flex>
                </v-layout>
                <!-- Event Description -->
                <v-layout row wrap class="py-1">
                    <v-flex xs6 class="grey--text text--darken-1">{{ $t('screener.quick.event.creation.step.form.field.description') }}</v-flex>
                    <v-flex xs6>
                        <div v-html="screener.description"></div>
                    </v-flex>
                </v-layout>
                <!-- Screening Start Date -->
                <v-layout row wrap class="py-1">
                    <v-flex xs6 class="grey--text text--darken-1">{{ $t('screener.save.form.starts_at') }}</v-flex>
                    <v-flex xs6>
                        <div>{{ screenerStartTime }}</div>
                    </v-flex>
                </v-layout>
                <!-- Screening End Date -->
                <v-layout row wrap class="py-1">
                    <v-flex xs6 class="grey--text text--darken-1">{{ $t('screener.save.form.ends_at') }}</v-flex>
                    <v-flex xs6>
                        <div>{{ screenerEndTime }}</div>
                    </v-flex>
                </v-layout>
                <!-- Screening End Date -->
                <v-layout row wrap class="py-1">
                    <v-flex xs6 class="grey--text text--darken-1">Media</v-flex>
                    <v-flex xs6>
                        <v-chip v-if="screener.films[0].external_url && screener.films[0].thumburls" color="success" small dark outline>Available</v-chip>
                        <v-chip v-else color="error" small dark outline>Unavailable</v-chip>
                    </v-flex>
                </v-layout>
                <!-- Auto Publish -->
                <!-- <v-layout row wrap class="py-1">
                    <v-flex xs6 class="grey--text text--darken-1">Auto Publishing</v-flex>
                    <v-flex xs6>
                        <v-chip v-if="screener.auto_publish" color="success" small dark outline>Active</v-chip>
                        <v-chip v-else color="error" small dark outline>Inactive</v-chip>
                    </v-flex>
                </v-layout> -->
            </v-flex>
            <v-flex xs12 md5 offset-md2 offset-xs0>
                <h3 class="mb-2">{{ $t('screener.monetization.title') }}</h3>
                <!-- Status -->
                <v-layout row wrap class="py-1">
                    <v-flex xs6 class="grey--text text--darken-1">Status</v-flex>
                    <v-flex xs6>
                        <v-chip v-if="screener.monetization_enabled" color="error" small dark>Paid</v-chip>
                        <v-chip v-else color="success" small dark>Free</v-chip>
                    </v-flex>
                </v-layout>
                <!-- Price -->
                <v-layout v-if="screener.monetization_enabled" row wrap class="py-1">
                    <v-flex xs6 class="grey--text text--darken-1">Price</v-flex>
                    <v-flex xs6>
                        <div>{{getCurrencySymbol(screener.monetization[DEFINES.MONETIZATION.PRICING_TYPE.SINGLE_PURCHASE][0].currency)}}&nbsp;{{ screener.monetization[DEFINES.MONETIZATION.PRICING_TYPE.SINGLE_PURCHASE][0].price }} {{ screener.monetization[DEFINES.MONETIZATION.PRICING_TYPE.SINGLE_PURCHASE][0].currency }}</div>
                    </v-flex>
                </v-layout>
                <h3 class="my-2">{{ $t('vod.save.geo_blocking') }}</h3>
                <!-- Status -->
                <v-layout row wrap class="py-1">
                    <v-flex xs6 class="grey--text text--darken-1">{{ $t('screener.save.overview.section.geo_restriction.status') }}</v-flex>
                    <v-flex xs6>
                        <v-chip v-if="screener.geo_blocking && screener.geo_blocking.blocking_for" color="success" small dark outline>Active</v-chip>
                        <v-chip v-else color="red" small dark outline>{{ $t('screener.status.inactive') }}</v-chip>
                    </v-flex>
                </v-layout>
                <!-- Restricting For -->
                <v-layout v-if="screener.geo_blocking && screener.geo_blocking.blocking_for" row wrap class="py-1">
                    <v-flex xs6 class="grey--text text--darken-1">Restricted For</v-flex>
                    <v-flex xs6>
                        <div>{{ screener.geo_blocking.blocking_for == DEFINES.GEO_BLOCKING.FOR.COUNTRIES?'Country':'City'}}</div>
                    </v-flex>
                </v-layout>
                <!-- Restriction Type -->
                <v-layout v-if="screener.geo_blocking && screener.geo_blocking.blocking_type" row wrap class="py-1">
                    <v-flex xs6 class="grey--text text--darken-1">Restriction Type</v-flex>
                    <v-flex xs6>
                        <div>{{ screener.geo_blocking.blocking_type == DEFINES.GEO_BLOCKING.TYPE.BLACKLIST?'Block':'Allow'}}</div>
                    </v-flex>
                </v-layout>
                <!-- Locations -->
                <v-layout v-if="screener.geo_blocking && screener.geo_blocking.blocking_for" class="py-1">
                    <v-flex xs6 class="grey--text text--darken-1">Locations</v-flex>
                    <v-flex xs6>
                        <div v-if="screener.geo_blocking.blocking_for == DEFINES.GEO_BLOCKING.FOR.COUNTRIES">India, United States</div>
                        <div v-if="screener.geo_blocking.blocking_for == DEFINES.GEO_BLOCKING.FOR.CITY">Bhilwara, Jaipur </div>
                    </v-flex>
                </v-layout>
                <h3 class="my-2">{{ $t('vod.save.step.player_configuration') }}</h3>
                <!-- Auto Play -->
                <v-layout row wrap class="py-1">
                    <v-flex xs6 class="grey--text text--darken-1">{{ $t('screener.quick.event.creation.step.form.player.configuration.option.allow_auto_play') }}</v-flex>
                    <v-flex xs6>
                        <div>{{ (screener.event_configuration && screener.event_configuration.auto_play)?'Allowed':'Disabled'}}</div>
                    </v-flex>
                </v-layout>
                <!-- Seeking -->
                <v-layout v-layout row wrap class="py-1">
                    <v-flex xs6 class="grey--text text--darken-1">{{ $t('screener.quick.event.creation.step.form.player.configuration.option.display_seeking') }}</v-flex>
                    <v-flex xs6>
                        <div>{{ (screener.event_configuration && screener.event_configuration.no_skip)?'Disabled':'Allowed'}}</div>
                    </v-flex>
                </v-layout>
                <!-- Pause & Play -->
                <v-layout v-layout row wrap class="py-1">
                    <v-flex xs6 class="grey--text text--darken-1">{{ $t('screener.quick.event.creation.step.form.player.configuration.option.disable_play') }}</v-flex>
                    <v-flex xs6>
                        <div>{{ (screener.event_configuration && screener.event_configuration.no_pause)?'Disabled':'Allowed'}}</div>
                    </v-flex>
                </v-layout>
                <!-- Full Screen Mode -->
                <v-layout v-layout row wrap class="py-1">
                    <v-flex xs6 class="grey--text text--darken-1">{{ $t('screener.quick.event.creation.step.form.player.configuration.option.full_screen') }}</v-flex>
                    <v-flex xs6>
                        <div>{{ (screener.event_configuration && screener.event_configuration.is_full_screen_mode)?'Allowed':'Disabled'}}</div>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-layout>
</template>

<script>
import DEFINES from '@/defines'
import { mapState, mapGetters } from 'vuex';
import { getCurrencySymbol } from "@/helper";
import moment from "moment";
export default {
    name: 'EventOverView',
    props: {
        screener:{
            type: Object,
            default: null
        },
        overviewScreenMessage: {
            type: Object,
            default: null
        }
    },
    computed: {
        ...mapGetters('company', {
            selected_company: 'getSelectedCompany',
        }),
        liveEventURL() {
            if (this.selected_company && this.screener) {
                return `${this.selected_company.domain}/screeners/${this.screener.id}`;
            }
        },
        screenerStartTime() {
            if (this.screener) {
                return moment(this.screener.screening_starts_at).format("dddd, MMMM Do YYYY, h:mm a")
            }
        },
        screenerEndTime() {
            if (this.screener) {
                return moment(this.screener.screening_ends_at).format("dddd, MMMM Do YYYY, h:mm a")
            }
        }
    },
    data() {
        return {
            sampleVideo: DEFINES.QUICK_EVENT.SAMPLE_VIDEO.VIMEO,
            magic_link_url:null
        }
    },
    methods: {
        async getMagicLink() {
            await this.$store
            .dispatch('screenerAccessLink/getMagicLink', {
                screener_id: this.screener.id,
            })
            .then((response) => {
                if (response.magic_link) {
                    var uuid = response.magic_link.id;
                    this.magic_link_url = `${this.selected_company.domain}/screeners/${this.screener.id}/link/${uuid}`;
                }
            })
            .catch((error) => {
                console.error(error);
            });
        },
        getCurrencySymbol() {
            return getCurrencySymbol(this.currency);
        },
    }
}
</script>

<style scoped>
.screener-card-preview {
    border: 1px solid black !important;
    border-radius: 10px !important;
}
.word-break{
    word-wrap: break-word
}
.text-bold {
    font-weight: bolder;
}
</style>
